<template>
  <section id="request-form">
    <Transition name="fade">
      <div @click="closeModal" v-show="!isHidden" class="modal__bg"></div>
    </Transition>
    <Transition name="slide-fade">
      <form
        @submit.prevent="submitForm"
        v-show="!isHidden && !isSent"
        class="modal"
      >
        <div @click="closeModal" class="modal__close">
          <svg
            width="23"
            height="22"
            viewBox="0 0 23 22"
            fill=""
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#000"
              d="M1.954.04L22.46 20.546l-1.414 1.414L.54 1.454z"
            ></path>
            <path
              fill="#000"
              d="M.54 20.546L21.046.04l1.414 1.414L1.954 21.96z"
            ></path>
          </svg>
        </div>
        <h2 class="modal__title">{{ title || "Оставить заявку на звонок" }}</h2>
        <div class="modal__inputs">
          <label class="modal__label" for="modalName">Ваше имя</label>
          <input
            placeholder="Имя"
            class="modal__input"
            type="text"
            name="modalName"
            id="modalName"
            v-model="name"
            :class="{ error: !name && errorStyle }"
          />
          <label class="modal__label" for="modalPhone">Ваш телефон</label>
          <input
            v-maska="'+7 (###) ###-##-##'"
            placeholder="Телефон"
            class="modal__input"
            type="text"
            name="modalPhone"
            id="modalPhone"
            v-model="phoneNumber"
            :class="{ error: !phoneNumber && errorStyle }"
          />
          <label class="modal__label" for="modalSelect">Выберите ДЦ</label>
          <select
            class="modal__input modal__select"
            name="modalSelect"
            id="modalSelect"
            v-model="location"
            :class="{ error: !location && errorStyle }"
          >
            <option hidden disabled value="">ДЦ</option>
            <option value="dc_1">ул. Щербакова, 144</option>
            <option value="dc_2">ул. Березовский тракт 11А ЕКАД</option>
          </select>
          <input
            id="modalText"
            type="text"
            name="modal-text"
            v-model="fakeField"
            tabindex="-1"
            style="position: absolute; top: 0; left: -5000px"
          />
        </div>
        <YandexSmartCaptcha
          siteKey="ysc1_XDdhZT58EBD9h2L9NOH5k2K73flmUtwCriCPZBQH11af89a5"
          class="modal__captcha"
          @onSuccess="successCaptcha"
          @onTokenExpired="errorCaptcha"
        />
        <div class="modal__footer">
          <div class="modal__text">
            <p>Нажимая «Оставить заявку»</p>
            <div class="modal__text-item">
              <input
                class="modal__checkbox"
                v-model="isAgree"
                type="checkbox"
                id="modal-checkbox-agree"
              />
              <label for="modal-checkbox-agree">
                Я согласен на
                <span @click="toggleAgree">
                  обработку моих персональных данных.
                </span>
              </label>
            </div>
            <div class="modal__text-item">
              <input
                class="modal__checkbox"
                v-model="isProcessing"
                type="checkbox"
                id="modal-checkbox-processing"
              />
              <label for="modal-checkbox-processing">
                С политикой в отношении
                <span @click="togglePrivacy">
                  обработки персональных данных ознакомлен и согласен.
                </span>
              </label>
            </div>
          </div>
          <button
            @click="submitForm"
            :disabled="btnDisabled"
            class="btn-primary modal__btn"
          >
            Заказать звонок
          </button>
        </div>
      </form>
    </Transition>
    <Transition name="fade">
      <div class="success modal" v-show="!isHidden && isSent">
        <img class="success__img" src="@/img/icons/success-g.svg" alt="" />
        <h2 class="modal__title success__title">Заявка отправлена</h2>
        <p class="modal__text success__text">
          Спасибо за обращение! В ближайшее время наши менеджеры свяжутся с вами
          и ответят на все интересующе вопросы
        </p>
      </div>
    </Transition>
  </section>
</template>

<script>
import { YandexSmartCaptcha } from "@gladesinger/vue3-yandex-smartcaptcha";
import axios from "axios";

export default {
  name: "RequestFormComponent",
  components: {
    YandexSmartCaptcha,
  },
  data() {
    return {
      URL: process.env.VUE_APP_API_URL,
      isHidden: true,
      privacyIsHidden: true,
      title: "",
      name: "",
      phoneNumber: "",
      car: "",
      location: "",
      form_position: "",
      fakeField: "",
      isSent: false,
      errorStyle: false,
      btnDisabled: true,
      isAgree: false,
      isProcessing: false,
      agreeIsHidden: true,
      processingIsHidden: true,
      token: "",
    };
  },
  mounted() {
    this.emitter.on("open-request-form", (data) => {
      this.isHidden = data.open;
      this.title = data.title;
      this.car = data.car;
      this.form_position = data.form_position;
    });
    this.emitter.on("open-privacy", (data) => {
      this.privacyIsHidden = data.open;
    });
    this.emitter.on("open-agree-processing", (data) => {
      this.agreeIsHidden = data.open;
    });
  },
  methods: {
    validation() {
      return this.name &&
        this.phoneNumber &&
        this.location &&
        this.isAgree &&
        this.isProcessing &&
        this.token
        ? true
        : false;
    },
    submitForm() {
      if (!this.validation()) {
        this.errorStyle = true;
      }
      if (this.validation()) {
        const formData = {
          name: this.name,
          phone: this.phoneNumber,
          location: this.location,
          car: this.car,
          form_position: this.form_position,
        };

        if (this.fakeField.length) return;

        axios
          .post(`${this.URL}form/callback`, formData)
          .then((response) => response)
          .catch((error) => console.log(error));

        const params = {
          fio: formData.name,
          phoneNumber: formData.phone.replace(/\D/g, ""),
          subject: this.getCenterName(this.location),
          sessionId: window.ct("calltracking_params", "xse1pw5k")?.sessionId,
          tags:
            this.getCenterName(this.location) === "Екатеринбург"
              ? "Щербакова"
              : "Березовский",
        };

        const siteId = "54043";

        axios
          .get(
            `https://api.calltouch.ru/calls-service/RestAPI/requests/${siteId}/register/`,
            { params },
          )
          .then((response) => {
            if (response.data.subject === "Екатеринбург") {
              window.ym(90439488, "reachGoal", "lead_sale");
            } else {
              window.ym(90439488, "reachGoal", "lead_service");
            }
            console.log("Отправка заявки в CallTouch удалась");
            window.ym(90439488, "reachGoal", "deal-calltouch");
          })
          .catch((error) => {
            console.log(
              `Отправка заявки в CallTouch не удалась. Причина: ${error}.`,
            );
          });

        this.isSent = true;
        this.errorStyle = false;
        this.name = null;
        this.phoneNumber = null;
        this.location = "ДЦ";
        setTimeout(() => (this.isHidden = true), 2000);
        setTimeout(() => (this.isSent = false), 2000);
      }
    },
    getCenterName(value) {
      return value === "dc_1" ? "Екатеринбург" : "Березовский";
    },
    closeModal() {
      this.isHidden = true;
    },
    togglePrivacy() {
      this.emitter.emit("open-privacy", {
        open: false,
      });
    },
    toggleAgree() {
      this.emitter.emit("open-agree-processing", {
        open: false,
      });
    },
    successCaptcha(token) {
      this.token = token;
      this.btnDisabled = false;
    },
    errorCaptcha() {
      this.isError = true;
      setTimeout(() => this.closeModal(), 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
